import { FC, memo, ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCompatibilityCheck } from '../hooks/use-compatibility-check';
import { cn } from '../utils/class-names.util';

interface Props {
  fitContent?: boolean;
  children?: ReactNode;
}

export const CommonCompatibilityCheck: FC<Props> = memo(
  ({ fitContent, children }) => {
    const { t } = useTranslation('common');

    const containerClass = useMemo(() => {
      return cn(
        'bg-background relative flex min-h-screen w-full items-center justify-center',
        fitContent && 'min-h-0 w-auto'
      );
    }, [fitContent]);

    const isCompatible = useCompatibilityCheck();

    if (!isCompatible()) {
      return (
        <div className={containerClass}>
          <div className="mx-auto flex max-w-sm flex-col items-center justify-center gap-4">
            <div className="flex flex-col items-center gap-2">
              <p className="text-foreground-muted text-center text-sm">{t('browserNotSupported')}</p>
            </div>
          </div>
        </div>
      );
    }
    return <>{children}</>;
  },
  () => true
);
CommonCompatibilityCheck.displayName = 'CommonCompatibilityCheck';
